export default __webpack_public_path__ + "static/media/addContent.1cd5ad99.svg";